import React from "react";

interface ProfilePictureProps {
  username: string;
  className?: string;
  textStyle?: string;
  gender?: string;
}

const ProfilePicture: React.FC<ProfilePictureProps> = ({
  username,
  className,
  textStyle,
  gender,
}) => {
  console.log(gender);
  

  return (
    <img
      className={className}
      src={
        gender !== "Male"
          ? "https://ik.imagekit.io/ok2wgebfs/_freepicdownloader.com_-funny-carton-normal.jpg?updatedAt=1739203217574"
          : "https://ik.imagekit.io/ok2wgebfs/_freepicdownloader.com_-cartoon-nurse-room-with-desk-window-generative-ai-medium.jpg?updatedAt=1739005178478"
      }
      alt="doctor"
    ></img>
  );
};

export default ProfilePicture;
